import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../Success/Success.css';

const Cancel = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [orderId, setOrderId] = useState('');
  
  useEffect(() => {
    // Get the order_id from URL query parameter
    const params = new URLSearchParams(location.search);
    const queryOrderId = params.get('order_id');
    
    if (queryOrderId) {
      console.log('Order ID from URL:', queryOrderId);
      setOrderId(queryOrderId);
    } else if (location.state?.orderDetails?.orderId) {
      console.log('Order ID from state:', location.state.orderDetails.orderId);
      setOrderId(location.state.orderDetails.orderId);
    } else {
      console.log('No order ID found, using default');
      setOrderId('');
    }
  }, [location]);

  return (
    <div className="payment-success-page">
      <h1 className="payment-title">{t('payment.title')}</h1>
      
      <div className="success-card">
        <div className="success-content">
          <h2>{t('payment.cancelTitle')}</h2>
          <p className="success-message">{t('payment.orderCancelled')}</p>
          <p className="success-info">
            {t('payment.cancelInfo')}
          </p>
          
          {orderId && (
            <div className="order-number">
              <p>{t('payment.orderNumber')}: {orderId}</p>
            </div>
          )}
          
          <Link to="/services" className="track-btn">
            {t('payment.tryAgain')}
          </Link>
          
          <Link to="/" className="home-btn">
            {t('payment.returnHome')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Cancel; 